import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from '../../context';
import FeaturesManager from 'utils/features/FeaturesManager';
import FieldBank from './FieldBank';
import TemplateManagement from './Templates';
import ReviewWorkflows from './ReviewWorkflows';
import EarlyInterventionSystem from './EarlyInterventionSystem';
import { PERFORMANCE_REPORTING_NAV_ITEMS } from './navItems';

// Register features with orgPermissions
FeaturesManager.registerFeature({
  id: 'performanceReportingView',
  name: 'Performance Reporting (View Only)',
  description: 'Enable Performance Reporting View Only',
  enabled: false,
  maxEnv: 'prod',
  orgPermissions: ['viewFieldBank'],
});

FeaturesManager.registerFeature({
  id: 'performanceReportingManager',
  name: 'Performance Reporting (Manager)',
  description: 'Enable Performance Reporting Manager',
  enabled: false,
  maxEnv: 'prod',
  orgPermissions: ['manageFieldBank', 'viewFieldBank', 'viewReviewWorkflow', 'viewEarlyInterventionSystem'],
});

export default function PerformanceReporting() {
  const {
    hasPermission,
    enforcePermissions,
    setCurrentModule,
    registerNavItems,
    currentOrganizationId,
    isLexipolStaff,
  } = useContext(AppContext);

  const getDefaultRoute = () => {
    if (hasPermission('viewFieldBank', currentOrganizationId || '')) {
      if (isLexipolStaff) {
        return <Navigate to='field-bank' />;
      }
      return <Navigate to='templates' />;
    }
    return <Navigate to='/admin/dashboard' />;
  };

  useEffect(() => {
    setCurrentModule('performanceReporting');
    registerNavItems('performanceReporting', PERFORMANCE_REPORTING_NAV_ITEMS);
  }, [setCurrentModule, registerNavItems]);

  return (
    <Routes>
      <Route
        path=''
        element={getDefaultRoute()}
      />
      <Route
        path='field-bank/*'
        element={enforcePermissions(['viewFieldBank'], <FieldBank />)}
      />
      <Route
        path='templates/*'
        element={enforcePermissions(['viewFieldBank'], <TemplateManagement />)}
      />
      <Route
        path='review-workflows/*'
        element={enforcePermissions(['viewReviewWorkflow'], <ReviewWorkflows />)}
      />
      <Route
        path='early-intervention-system/*'
        element={enforcePermissions(['viewEarlyInterventionSystem'], <EarlyInterventionSystem />)}
      />
    </Routes>
  );
}
